import React from 'react'
import { Dialog, Toolbar, IconButton, Card, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import defaultImage from "../images/default-image.png"

const styles = {
    closeButton: {
        position: 'absolute',
        right: 10,
        top: 2,
        color: 'inherit',
    },
    card: {
        width: "100%",
        height: "400px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    media: {
        width: 350,
        height: 350,
        borderRadius: "10px",
    }
}
const parseId = (id) => {
    return id.replace(/\//g, ' - ');
}


export default function Image(props) {
    const { image, open, onClose } = props;
    return (
        image !== "" &&
        <Dialog open={open} maxWidth={'xs'} fullWidth>
            <Toolbar variant='dense'>
                <IconButton style={styles.closeButton} onClick={() => onClose()} size='large'>
                    <CloseIcon />
                </IconButton>
                <Typography>
                    {image?.productDescription}
                </Typography>
            </Toolbar>
            <Card style={styles.card}>
                <img
                    style={styles.media}
                    alt={image.productDescription}
                    src={`${process.env.PUBLIC_URL}/assets/Catalogo/${parseId(image.productId)}.jpg`}
                    onError={(e) => {
                        e.target.src = defaultImage;
                    }}
                />
            </Card>
        </Dialog>
    );
}



